import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import { db } from "../../services/firebase";
import axios from "axios";

Vue.use(Vuex);
//const hostDB = "firebase";
const hostDB = "mysql";
//const hostAPI = "http://18.191.117.219/api";
const hostAPI = "https://opensoils.org/api";

export default new Vuex.Store({
	state: {
		cenario: {},
		cenarioVR: {},
		cenarios: [],
		cenariosVR: [],
		projetos: [],
	},
	mutations: {
		SET_CENARIO(state, payload) {
			state.cenario = payload;
		},
		SET_CENARIOS(state, payload) {
			state.cenarios = payload;
		},
		SET_CENARIOSVR(state, payload) {
			state.cenariosVR = payload;
		},
		SET_CENARIOVR(state, payload) {
			state.cenarioVR = payload;
		},
		SET_PROJETOS(state, payload) {
			state.projetos = payload;
		},
	},
	actions: {
		async getProjetos({ commit }){
			let aux = [];
			const response = await axios.get(hostAPI + "/projeto")
			aux = response.data;
			commit("SET_PROJETOS", aux);
		},

		async getCenariosByProjeto({ commit }, projeto){
			let aux = [];
			const response = await axios.get(hostAPI + "/projeto/" + projeto + "/observacao");
			aux = response.data;
			commit("SET_CENARIOS", aux);
		},

		async getCenarios({ commit }) {
			let aux = [];
			if (hostDB == "firebase") {
				const query = await db.collection("cenarios").get();
				query.docs.forEach((doc) => {
					if (doc.exists) {
						aux.push(doc.data());
					}
				});
			} else {
				const response = await axios.get(hostAPI + "/observacaoIncompleta");
				aux = response.data;
			}
			commit("SET_CENARIOS", aux);
		},

		async getCenariosVR({ commit }) {
			let aux = [];
			const query = await db.collection("cenarios").get();
			query.docs.forEach((doc) => {
				if (doc.exists) {
					aux.push(doc.data());
				}
			});
			commit("SET_CENARIOSVR", aux);
		},

		async getCenariosBySolo({ commit }, tipo) {
			let aux = [];
			if (hostDB == "firebase") {
				//todo
			} else {
				const response = await axios.get(hostAPI + "/observacaoSibcs?valor=" + tipo + "&sibcs=atual");
				aux = response.data;
			}
			commit("SET_CENARIOS", aux);
		},

		async getCenarioByIdOpenSoils({ commit }, id) {
			let aux = {};
			const query = await db.collection("cenarios").get();
			query.docs.forEach((doc) => {
				if (doc.exists) {
					if (doc.data().idOpenSoilsBD == id) {
						aux = doc.data(); //aux.push(doc.data());
					}
				}
			});
			//console.log(aux);
			commit("SET_CENARIOVR", aux);
		},

		async getCenario({ commit }, id) {
			let aux = {};
			if (hostDB == "firebase") {
				await db
					.collection("cenarios")
					.doc(id)
					.get()
					.then((doc) => {
						aux = doc.data();
						aux.id = doc.id;
					});
			}else{
				const response = await axios.get(hostAPI + "/observacao/" + id);
				aux = response.data;
			}
			commit("SET_CENARIO", aux);
		},

		async setCenario({ commit }, newCenario) {
			console.log("TESTE: ",newCenario);
			console.log("commit:",commit);
			try {
				await db
					.collection("cenarios")
					.doc(newCenario.idOpenSoilsBD.toString())
					.set(newCenario);
			} catch (error) {
				console.log(error);
			}
		},

		async upload({ dispatch }, { imageName, imageFile, cenarioOpenSoils }) {
			if (imageName != "" && imageFile != "") {
				var storageRef = firebase.storage().ref();
				//var mountainsRef = storageRef.child(`images/${imageName}`);
				var mountainsRef = storageRef.child(`images/foto${cenarioOpenSoils.id_observacao}`);
				mountainsRef.put(imageFile).then((snapshot) => {
					snapshot.ref.getDownloadURL().then((downloadURL) => {
						//const bucketName = "open-soils-vr.appspot.com";
						//const filePath = imageName;
						//downloadUrl: `https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/images` +"%2F"+`${encodeURIComponent(filePath)}?alt=media`
						const cenario = {
							idOpenSoilsBD: cenarioOpenSoils.id_observacao,
							imagem: downloadURL
						}			
						dispatch("setCenario", cenario);
					});
				});
			}
		},
	},
	modules: {},
});
